import type { FormField } from '@cli-types/core-engine/schema.js'

export function getListFields(fields: FormField[]): FormField[] {
  return fields.filter((f) => f.name && f.type === 'list' && f.fields && f.fields.length > 0)
}
